import { render, staticRenderFns } from "./InfoFaturaModal.vue?vue&type=template&id=4be9639c&scoped=true"
import script from "./InfoFaturaModal.vue?vue&type=script&lang=js"
export * from "./InfoFaturaModal.vue?vue&type=script&lang=js"
import style0 from "./InfoFaturaModal.vue?vue&type=style&index=0&id=4be9639c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be9639c",
  null
  
)

export default component.exports